{
  "data": {
    "chapterSelect": {
      "arrayMultiPageAggregate": true,
      "arrayMultiPageBuilder": true,
      "arraySinglePage": true,
      "checkbox": true,
      "date": true,
      "internationalPhone": true,
      "fileInput": true,
      "fileInputMultiple": true,
      "formsPattern": true,
      "miscellaneous": true,
      "numberInput": true,
      "radio": true,
      "select": true,
      "textInput": true,
      "serviceBranch": true
    },
    "dateDefault": "1999-02-02",
    "dateCurrentOrPast": "2005-04-12",
    "dateCurrentOrFuture": "2050-06-15",
    "dateAny": "2010-07-04",
    "dateOnOrAfter": "2030-06-15",
    "dateRangeMixed": {
      "from": "2015-01-05",
      "to": "2050-06-15"
    },
    "dateWcv3": "2000-02-12",
    "dateDigitsWcv3": "2001-03-15",
    "dateRange": {
      "from": "1999-01-03",
      "to": "1999-01-03"
    },
    "dateMonthYear": "1999-02",
    "dateMonthYearOptional": "1999-XX",
    "dateMonthYearRange": {
      "from": "1999-01",
      "to": "1999-01"
    },
    "wcv3FileInput": {
      "name": "my_form.pdf",
      "size": 12345,
      "fileType": "application/pdf",
      "confirmationCode": "7564298",
      "additionalData": {
        "documentStatus": "private"
      }
    },
    "wcv3FileInputMultiple": [
      {
        "name": "my_form.pdf",
        "size": 2048,
        "type": "application/pdf",
        "confirmationCode": "123abc",
        "additionalData": {
          "documentStatus": "private"
        }
      },
      {
        "name": "my_png.png",
        "size": 2048,
        "type": "image/png",
        "confirmationCode": "456efg",
        "additionalData": {
          "documentStatus": "public"
        }
      }
    ],
    "vaCompensationType": "none",
    "isCurrentlyActiveDuty": false,
    "wcv3VaCompensationType": "highDisability",
    "wcv3VaTileCompensationType": "none",
    "wcv3IsCurrentlyActiveDuty": true,
    "amountOrNumber": "123",
    "selectDefault": "option1",
    "wcv3SelectSimple": "Option 1",
    "wcv3SelectValues": "Option 1",
    "wcv3SelectKeyValues": "option1",
    "wcv3TextEmailNew": "abc@abc.com",
    "wcV3SimpleCheckbox": true,
    "wcV3SimpleCheckboxRequired": true,
    "wcV3DynamicRequiredCheckbox": true,
    "rjsfCheckSimpleTextInput": "Lorem ipsum dolor sit amet",
    "rjsfCheckRequiredCheckbox": true,
    "rjsfCheckSsn": "454544545",
    "rjsfCheckboxWithBackground": {},
    "wcOldCheckSimpleText": "Lorem ipsum dolor sit amet",
    "wcOldCheckRequiredCheckbox": true,
    "wcOldCheckSsn": "454544545",
    "wcOldCheckboxWithBackground": {},
    "wcV3CheckSimpleText": "s",
    "wcV3CheckRequiredCheckbox": true,
    "wcV3CheckSsn": "454544545",
    "wcV3CheckboxWithBackground": {},
    "ssn": "454544545",
    "wcOldSsn": "454544545",
    "wcv3SsnNew": {
      "ssn": "454544545"
    },
    "addressOld": {
      "country": "USA",
      "street": "1234 Main St",
      "city": "City",
      "state": "AL",
      "postalCode": "12345"
    },
    "wcv3Address": {
      "country": "USA",
      "street": "1234 Main St",
      "city": "City",
      "state": "AL",
      "postalCode": "12345"
    },
    "spouseFullNameOld": {
      "first": "Person",
      "middle": "Middle",
      "last": "LastName"
    },
    "wcOldSpouseFullName": {
      "first": "Person",
      "middle": "Middle",
      "last": "LastName"
    },
    "wcv3SpouseFullNameNew": {
      "first": "Person",
      "middle": "Middle",
      "last": "LastName"
    },
    "requiredOld": "Lorem ipsum dolor sit amet",
    "wcOldRequired": "Lorem ipsum dolor sit amet",
    "wcv3RequiredNew": "Lorem ipsum dolor sit amet",
    "wcv3TextAreaNew": "Lorem ipsum dolor sit amet",
    "wcv3RelationshipToVeteran": {
      "relationshipToVeteran": "spouse"
    },
    "checkboxGroupAtLeastOneRequired": {
      "hasA": true
    },
    "checkboxGroupTiledWithCustomErrorMessage": {
      "hasA": false,
      "hasB": true
    },
    "checkboxGroupTiledWithHeaderLabel": {
      "hasB": true
    },
    "formsPatternSingleRadio": "1",
    "formsPatternSingleCheckboxGroup": {
      "1": true
    },
    "formsPatternMultiple": "Test",
    "formsPatternOtherField": "Test",
    "arrayBuilderPatternFlowType": "optional",
    "arrayBuilderPatternInteractionType": "yesNoQuestion",
    "arrayBuilderItemPages": "complex",
    "arrayBuilderSummaryIntroVariation": "A",
    "exampleArrayOne": [
      {
        "facilityName": "facility a",
        "from": "2000-01-09",
        "to": "2001-02-09"
      },
      {
        "facilityName": "facility b",
        "from": "2010-03-03",
        "to": "2011-12-19"
      }
    ],
    "exampleArrayTwo": [
      {
        "name": "Record a",
        "proof": true
      },
      {
        "name": "Record b",
        "proof": false,
        "checkbox": true
      }
    ],
    "exampleArrayData": [
      {
        "address": {
          "country": "USA",
          "street": "street",
          "city": "city",
          "state": "AL",
          "postalCode": "11111"
        },
        "fullName": {
          "first": "Alpha",
          "middle": "Bravo",
          "last": "Cap"
        }
      },
      {
        "address": {
          "country": "AUS",
          "street": "street2",
          "city": "city2",
          "postalCode": "22222"
        },
        "fullName": {
          "first": "Delta",
          "last": "Cap"
        }
      }
    ],
    "view:hasEmployment": false,
    "nameCustom": "Test",
    "wcv3InternationalPhone": {
      "countryCode": "US",
      "contact": "(234) 567-8910",
      "callingCode": "1",
      "isValid": true,
      "error": null
    },
    "wcv3ServiceBranchDefault": "NAVY",
    "wcv3ServiceBranchCustom": "CG",
    "wcv3ServiceBranchCustomBranches": "PHS"
  }
}
